import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <main className="bg-indigo-800 text-white min-h-screen flex items-center justify-center relative">
      <Helmet>
        <meta name="description" content="Page not found - Codexa" />
      </Helmet>

      {/* Background Animation */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-indigo-800"
        initial={{ opacity: 0.5 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, ease: 'easeInOut' }}
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="text-center relative z-10"
      >
        {/* Animated 404 Header */}
        <motion.h1
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="text-6xl font-bold mb-6"
        >
          404
        </motion.h1>

        {/* Error Message */}
        <motion.p
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="text-xl mb-6 text-gray-200"
        >
          Oops! The page you are looking for doesn't exist.
        </motion.p>

        {/* Animated CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
        >
          <Link
            to="/"
            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-8 py-3 rounded-full shadow-lg transition transform hover:scale-105"
          >
            Go Back to Home
          </Link>
        </motion.div>
      </motion.div>

      {/* Floating Animation for Visual Appeal */}
      <motion.div
        className="absolute bottom-5 left-1/2 transform -translate-x-1/2"
        animate={{
          y: [0, -10, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: 'loop',
          ease: 'easeInOut',
        }}
      >
        <motion.div
          animate={{ rotate: [0, 360] }}
          transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
          className="w-20 h-20 rounded-full bg-indigo-500 flex items-center justify-center"
        >
          <span className="text-white text-xl font-semibold">404</span>
        </motion.div>
      </motion.div>
    </main>
  );
};

export default NotFoundPage;
